/** Client-side mirror of src/mrp/infer-carrier-from-tracking.ts for form auto-fill. */

export function inferCarrierFromTrackingNumber(tracking: string): string | null {
  const normalized = tracking.trim().replace(/\s+/g, "").toUpperCase();
  if (normalized === "") {
    return null;
  }
  if (/^1Z[0-9A-Z]{16}$/i.test(normalized)) {
    return "UPS";
  }
  if (/^TBA[0-9A-Z]+$/i.test(normalized)) {
    return "Amazon";
  }
  if (/^\d{12}$/.test(normalized) || /^\d{15}$/.test(normalized) || /^\d{34}$/.test(normalized)) {
    return "FedEx";
  }
  if (/^(94|93|92|95)\d{18,20}$/.test(normalized) || (/^[0-9]{20,22}$/.test(normalized) && normalized.startsWith("9"))) {
    return "USPS";
  }
  if (/^\d{10,11}$/.test(normalized)) {
    return "DHL";
  }
  return null;
}
